import { lazy } from 'react';
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import { RequireAuth } from './IsLoggedIn.jsx';

// ── Pages ──────────────────────────────────────────────────────────────────
const DashboardDefault = Loadable(lazy(() => import('../pages/dashboard/default')));
const NotFound = Loadable(lazy(() => import('../pages/component-overview/NotFoundPage')));
const Categories = Loadable(lazy(() => import('../pages/component-overview/Categories/CategoriesPage')));
const QRBatch = Loadable(lazy(() => import('../pages/component-overview/QRBatch/QRBatchPage')));
const QRBatchCreate = Loadable(lazy(() => import('../pages/component-overview/QRBatchCreate/QRBatchCreatePage')));
const QRBatchDetail = Loadable(lazy(() => import('../pages/component-overview/QRBatch/QRBatchDetailPage')));
const Products = Loadable(lazy(() => import('../pages/component-overview/Products/ProductsPage')));
const Claim = Loadable(lazy(() => import('../pages/component-overview/Claims/ClaimsPage')));
const ClaimDetail = Loadable(lazy(() => import('../pages/component-overview/Claims/ClaimDetail')));
const Users = Loadable(lazy(() => import('../pages/component-overview/Users/UsersPage')));
const ProdVerify = Loadable(lazy(() => import('../pages/component-overview/Dispatch/DispatchPage')));
const GlobalSettings = Loadable(lazy(() => import('../pages/component-overview/Settings/GlobalSettingsPage')));
const ProductVerify = Loadable(lazy(() => import('../pages/component-overview/Products/ProductVerifyPage')));
const ReturnReasons = Loadable(lazy(() => import('../pages/component-overview/ReturnReasons/ReturnReasonsPage')));
const ProductConditions = Loadable(lazy(() => import('../pages/component-overview/ProductConditions/ProductConditionsPage')));
const Promotions = Loadable(lazy(() => import('../pages/component-overview/Promotions/PromotionsPage')));
const Colors = Loadable(lazy(() => import('../pages/component-overview/Colors/ColorsPage')));
const MenuManagement = Loadable(lazy(() => import('../pages/component-overview/MenuManagement/MenuManagementPage')));
const Roles = Loadable(lazy(() => import('../pages/component-overview/Roles/RolesPage')));
const MyRewards = Loadable(lazy(() => import('../pages/component-overview/Loyalty/MyRewardsPage')));
const OfferCodesAdmin = Loadable(lazy(() => import('../pages/component-overview/OfferCodes/OfferCodesPage')));
const MyOffers = Loadable(lazy(() => import('../pages/component-overview/OfferCodes/MyOffersPage')));
const ScratchCampaignAdmin = Loadable(lazy(() => import('../pages/component-overview/Gamification/ScratchCampaignPage')));
const LuckyDrawAdmin = Loadable(lazy(() => import('../pages/component-overview/Gamification/LuckyDrawAdminPage')));
const ScratchCardCustomer = Loadable(lazy(() => import('../pages/component-overview/Gamification/ScratchCardPage')));
const LuckyDrawCustomer = Loadable(lazy(() => import('../pages/component-overview/Gamification/LuckyDrawPage')));
const ExportPage = Loadable(lazy(() => import('../pages/component-overview/Export/QRSampleExportPage')));
const Companies = Loadable(lazy(() => import('../pages/component-overview/Companies/CompaniesPage')));
const SubscriptionPlans = Loadable(lazy(() => import('../pages/dashboard/SubscriptionPlans')));
const CompanySubscriptions = Loadable(lazy(() => import('../pages/dashboard/CompanySubscriptions')));
const BusinessCategories = Loadable(lazy(() => import('../pages/dashboard/BusinessCategories')));
const LabelPrinting = Loadable(lazy(() => import('../pages/component-overview/LabelPrinting/LabelPrintingPage')));
const ScanAnalytics = Loadable(lazy(() => import('../pages/component-overview/ScanAnalytics/ScanAnalyticsPage')));
const ServiceCenters = Loadable(lazy(() => import('../pages/component-overview/ServiceCenters/ServiceCentersPage')));
const LoyaltyRules = Loadable(lazy(() => import('../pages/component-overview/Loyalty/LoyaltyRulesPage')));

const MainRoutes = {
  path: '/',
  element: <DashboardLayout />,
  children: [

    // ── Public Routes (login ki zaroorat nahi) ────────────────────────────
    {
      path: 'scan/:qrCode',
      element: <ProductVerify />
    },
    {
      path: 'verify',
      element: <ProductVerify />
    },
    {
      path: 'my-rewards',
      element: <MyRewards />
    },
    {
      path: 'my-offers',
      element: <MyOffers />
    },
    {
      path: 'my-cards',
      element: <ScratchCardCustomer />
    },
    {
      path: 'lucky-draw',
      element: <LuckyDrawCustomer />
    },
    {
      path: 'lucky-draw/:id',
      element: <LuckyDrawCustomer />
    },

    // ── Protected Routes (RequireAuth har render pe token check karta hai) ─
    {
      element: <RequireAuth />,
      children: [
        // Dashboard
        { index: true, element: <DashboardDefault /> },
        { path: 'dashboard', element: <DashboardDefault /> },
        { path: 'dashboard/default', element: <DashboardDefault /> },

        // Companies
        { path: 'companies', element: <Companies /> },

        // Export
        { path: 'export', element: <ExportPage /> },

        // Product Management
        { path: 'categories', element: <Categories /> },
        { path: 'return-reasons', element: <ReturnReasons /> },
        { path: 'colors', element: <Colors /> },
        { path: 'menu-management', element: <MenuManagement /> },
        { path: 'roles', element: <Roles /> },
        { path: 'promotions', element: <Promotions /> },
        { path: 'prod-conditions', element: <ProductConditions /> },
        { path: 'products', element: <Products /> },

        // Offer Codes & Gamification
        { path: 'offer-codes', element: <OfferCodesAdmin /> },
        { path: 'scratch-campaigns', element: <ScratchCampaignAdmin /> },
        { path: 'lucky-draws', element: <LuckyDrawAdmin /> },

        // QR Batch
        { path: 'qr-batch', element: <QRBatch /> },
        { path: 'qr-batch-create', element: <QRBatchCreate /> },
        { path: 'qr-batch/:id', element: <QRBatchDetail /> },

        // Claims
        { path: 'claims', element: <Claim /> },
        { path: 'claims/:id', element: <ClaimDetail /> },

        // Users
        { path: 'users', element: <Users /> },

        // Dispatch
        { path: 'prod-verify', element: <ProdVerify /> },
        {
          path: 'subscriptions-plans',
          element: <SubscriptionPlans />
        },
        {
          path: 'subscriptions-companies',
          element: <CompanySubscriptions />
        },
        { path: 'business-categories', element: <BusinessCategories /> },

        // Label printing, analytics, service centers, loyalty rules
        { path: 'label-printing', element: <LabelPrinting /> },
        { path: 'scan-analytics', element: <ScanAnalytics /> },
        { path: 'service-centers', element: <ServiceCenters /> },
        { path: 'loyalty-rules', element: <LoyaltyRules /> },

        // Settings
        { path: 'settings', element: <GlobalSettings /> },
      ]
    },

    // ── 404 ───────────────────────────────────────────────────────────────
    {
      path: '*',
      element: <NotFound />
    }
  ]
};

export default MainRoutes;